import CrudBaseService from "@/services/CrudBaseService";

export default class PlanEquivalenceConfigurationService extends CrudBaseService {
  constructor() {
    super('insurance_pricing/plan_equivalence_configuration');
  }

  save(equicConfId, carrierId, data) {
    return this.http.post(`${this._serviceName}/${equicConfId}/${carrierId}`, data);
  }

  findAllByParams(data) {
    return this.http.get(`${this._serviceName}/findAllByParams`, { params: data });
  }

  findByEquivalenceConfigurationAndPlan(data) {
    return this.http.get(`${this._serviceName}/findPlanEquivConf`, { params: data });
  }

}